export enum SessionGuideStepEnum {
  PICK_SESSION_TYPE = 'pickSessionType',
  SETUP_PLATFORM = 'setupPlatform',
  CREATE_SESSION = 'createSession',
}

export enum SessionTypeEnum {
  WITH_SERVICE_TYPE = 'withServiceType',
  WITHOUT_SERVICE_TYPE = 'withoutServiceType',
}

export enum CreateSessionStepEnum {
  CREATE_SESSION = 'createSession',
  ADD_SUPPLIERS = 'addSuppliers',
}
